import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import ViewPage from '../../../../Components/ViewPage'
import { TabelaOutrosAditivos } from './components/tabela'
import { FormularioAditivos } from './components/formulario'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { v4 as uid } from 'uuid'
import { listMedidas, tiposGerais } from '../../../../services/Afins'
import { getCategoriaMarcaInsumo } from '../../../../services/config/marca'
import { getFormulacao, TypeFormulacao } from '../../../../services/recomendacao/formulacao'
import { AxiosResponse } from 'axios'
import { useGetAditivos } from '../../../../services/aditivos/GET'
import { getTiposSistema } from '../../../../services/monitoramento/nivelControleItens'
import { usePostAditivos, usePutAditivos } from '../../../../services/aditivos/POST'
import { api } from '../../../../services/api'
import { useDeleteAditivo, usePutRemoverDose } from '../../../../services/aditivos/DELETE'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'

const OutrosAditivos: React.FC = () => {
  //TABELA
  const [update, setUpdate] = useState(0)
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [filtradoAtivo, setFiltradoAtivo] = useState<boolean>(false)
  const [total1, setTotal1] = useState(null)
  const [carregou, setCarregou] = useState(true)

  //FORMULARIO
  const [open, setOpen] = useState<boolean>(false)
  const [dataCulturas, setDataCulturas] = useState([])
  const [dataFabricante, setDataFabricante] = useState([])
  const [dataFormulacao, setDataFormulacao] = useState([])
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<
    'Dados do aditivos' | 'Dose por cultura'
  >('Dados do aditivos')
  const [nome_produto, setNome_produto] = useState<string>('')
  const [fabricante, setFabricante] = useState<string>('')
  const [fabricante_id, setFabricante_id] = useState<number>(null)
  const [tipo_aditivo, setTipo_aditivo] = useState<string>('')
  const [tipo_aditivo_id, setTipo_aditivo_id] = useState<number>(null)
  const [tipo_formulacao, setTipo_formulacao] = useState<string>('')
  const [tipo_formulacao_id, setTipo_formulacao_id] = useState<number>(null)
  const [modo_uso, setModo_uso] = useState<string>('')
  const [observacao, setObservacao] = useState<string>('')
  const [doses_culturas_adicionados, setDoses_culturas_adicionados] = useState([])
  const [cultura, setCultura] = useState<string>('')
  const [cultura_id, setCultura_id] = useState<number>(null)
  const [dose, setDose] = useState<string>('')
  const [dose_id, setDose_id] = useState<number>(null)
  const [valor, setValor] = useState<string>('')
  const [data_unidade, setData_unidade] = useState([])
  const [data_tipos_aditivos, setData_tipos_aditivos] = useState([])
  const [fake_loading_cultura, setFake_loading_cultura] = useState<boolean>(false)

  //API
  const { carregando_aditivos, data_aditivos, refetch_data_aditivos } = useGetAditivos(
    pagination,
    page,
    buscarTabela
  )
  const { carregando_salvar_aditivos, mutate_aditivos } = usePostAditivos()
  const { carregando_editar_aditivos, mutate_editar_aditivos } = usePutAditivos(update)
  const { carregando_remover_dose, mutate_remover_dose } = usePutRemoverDose()
  const { carregando_deletar_aditivos, mudateDeletarAditivos } = useDeleteAditivo()

  const listCultura = async () => {
    const resp = await tiposGerais()

    setDataCulturas(resp)
  }

  const listFormulacao = async () => {
    const response = await api.get(`/tipos-sistema?pagination=-1`)
    const filtro_formulacao = response.data.itens.filter((item) => item?.cod_tipo_geral === 247)
    setDataFormulacao(filtro_formulacao?.filter((item) => [270, 248].includes(item?.cod)))
  }

  const listFabricantes = async () => {
    const resp = await getCategoriaMarcaInsumo()
    setDataFabricante(resp.data.itens)
  }

  const listUnidadeMedida = async () => {
    const resp = await listMedidas()
    const filtro = resp?.filter((item) => [4, 2, 10, 16, 17, 18].includes(item?.cod))
    setData_unidade(filtro)
  }

  const listTipoAditivos = async () => {
    const response: AxiosResponse = await getTiposSistema({
      codTipo: 275,
    })

    setData_tipos_aditivos(response?.data?.itens)
  }

  function abrirGaveta() {
    setOpen(true)
  }

  function fecharGaveta() {
    setOpen(false)
    setUpdate(0)
    setNome_produto('')
    setFabricante('')
    setFabricante_id(null)
    setTipo_aditivo('')
    setTipo_aditivo_id(null)
    setTipo_formulacao('')
    setTipo_formulacao_id(null)
    setModo_uso('')
    setObservacao('')
    setDose('')
    setDose_id(null)
    setCultura('')
    setCultura_id(null)
    setValor('')
    setDoses_culturas_adicionados([])
    setTab_selecionar_atual('Dados do aditivos')
  }

  function editarAtivido(cod) {
    setUpdate(cod)
    const filtrado = data_aditivos?.itens.filter((item) => item?.cod === cod)
    setNome_produto(filtrado[0]?.nome)
    setFabricante(filtrado[0]?.fabricante_nome)
    setFabricante_id(filtrado[0]?.cod_fabricante)
    setTipo_aditivo(filtrado[0]?.tipo_aditivo_nome)
    setTipo_aditivo_id(filtrado[0]?.tipo_aditivo)
    setTipo_formulacao(filtrado[0]?.tipo_formulacao === 248 ? 'Líquida' : 'Sólido')
    setTipo_formulacao_id(filtrado[0]?.tipo_formulacao)
    setModo_uso(filtrado[0]?.descricao)
    setObservacao(filtrado[0]?.observacao)
    let cultura_adicionada = []
    filtrado[0]?.doses?.forEach((data) => {
      setDose_id(data?.cod_tipo_medida)
      setDose(data?.tipo_medida_nome)
      cultura_adicionada = [
        ...cultura_adicionada,
        {
          uid: uid(),
          cod: data?.cod,
          cod_cultura: data?.cod_cultura,
          cod_tipo_medida: data?.cod_tipo_medida,
          cultura_nome: data?.cultura_nome,
          dose: Number(data?.dose?.replace(',', '.')),
        },
      ]
    })
    setDoses_culturas_adicionados(cultura_adicionada)
    setOpen(true)
  }

  function salvarAditivo() {
    const dose_filtrada = doses_culturas_adicionados.map((item) => {
      return {
        cod_cultura: item?.cod_cultura,
        dose: item?.dose,
        cod_tipo_medida: item?.cod_tipo_medida,
      }
    })

    if (update <= 0) {
      mutate_aditivos({
        nome: nome_produto,
        cod_fabricante: fabricante_id,
        tipo_formulacao: tipo_formulacao_id,
        tipo_aditivo: tipo_aditivo_id,
        cod_categoria_produto: 25,
        descricao: modo_uso,
        observacao: observacao,
        doses: dose_filtrada,
        refetch: () => {
          refetch_data_aditivos()
          fecharGaveta()
        },
      })
    } else {
      mutate_editar_aditivos({
        nome: nome_produto,
        cod_fabricante: fabricante_id,
        tipo_formulacao: tipo_formulacao_id,
        tipo_aditivo: tipo_aditivo_id,
        cod_categoria_produto: 25,
        descricao: modo_uso,
        observacao: observacao,
        doses: dose_filtrada,
        refetch: () => {
          refetch_data_aditivos()
          fecharGaveta()
        },
      })
    }
  }

  const adicionarCultura = async () => {
    const check = doses_culturas_adicionados.find((data) => data.cod_cultura === cultura_id)

    if (check !== undefined) {
      errorAlert('Dose para cultura já inserido!')

      return
    }

    if (cultura === '' || cultura_id === 0 || valor === '') {
      errorAlert('Preencha todos os campos!')
    } else {
      setDoses_culturas_adicionados([
        ...doses_culturas_adicionados,
        {
          uid: uid(),
          cod: null,
          cod_cultura: cultura_id,
          cod_tipo_medida: dose_id,
          cultura_nome: cultura,
          dose: Number(valor?.replace(',', '.')),
        },
      ])
    }

    setCultura('')
    setCultura_id(null)
    setValor('')
  }

  const remover_cultura_dose = async (uid, cod = null, cod_cultura) => {
    setFake_loading_cultura(true)
    const dados = [...doses_culturas_adicionados]
    let filtro = []
    if (cod === null) {
      filtro = dados.filter((data) => data.cod_cultura !== cod_cultura)
      setFake_loading_cultura(false)
      return setDoses_culturas_adicionados(filtro)
    } else {
      loadingAlert({ msg: 'Removendo...', id: 'remover_cultura_dose' })
      mutate_remover_dose({
        cod: update,
        doses_remover: [cod_cultura],
        refetch: refetch_data_aditivos,
      })
      filtro = dados.filter((data) => data.cod_cultura !== cod_cultura)
      setFake_loading_cultura(false)
      return setDoses_culturas_adicionados(filtro)
    }
  }

  function deletarAditivos(cod) {
   
    mudateDeletarAditivos({
      cod_aditivos: cod,
      refetch_deletar: refetch_data_aditivos,
    })

  
  }

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        setFiltradoAtivo(true)
        refetch_data_aditivos()
      }, 700)
    }

    if (carregou === false) {
      if (buscarTabela === '' || buscarTabela.length <= 0) {
      setTimeout(() => {
        refetch_data_aditivos()
        setFiltradoAtivo(false)
      }, 700)
    }
    }
  }, [buscarTabela])

  useEffect(() => {
    if (filtradoAtivo === false) {
      setTotal1(data_aditivos?.total)
    }
  }, [data_aditivos?.total])

  useEffect(() => {
    refetch_data_aditivos()
  }, [page, pagination])

  useEffect(() => {
    listCultura()
    listFabricantes()
    listUnidadeMedida()
    refetch_data_aditivos()
    listTipoAditivos()
    listFormulacao()
    setTimeout(() => {
      setCarregou(false)
    }, 700)
  }, [])

  return (
    <ViewPage
      title='Aditivos'
      rotina={112}
      onPermission={setPermissions}
      hiddeTitle
      cardBodyStyle={{ padding: 15 }}
      cardMainStyle={{ height: '87.5vh' }}
      newHide
    >
      <div style={{ marginBottom: '10px' }}>
        <TitleH1>Aditivos</TitleH1>
      </div>
      <TabelaOutrosAditivos
        loading={carregando_aditivos}
        list_aditivos={data_aditivos?.itens}
        permissions={permissions}
        deletar={deletarAditivos}
        abrir={abrirGaveta}
        editar={editarAtivido}
        buscarTabela={buscarTabela}
        setBuscarTabela={setBuscarTabela}
        page={page}
        setPage={setPage}
        total={data_aditivos?.total}
        confirmar_exclusao={confirmar_exclusao}
        setConfirmar_exclusao={setConfirmar_exclusao}
        id_item_atual={id_item_atual}
        setId_item_atual={setId_item_atual}
        nome_item_atual={nome_item_atual}
        setNome_item_atual={setNome_item_atual}
        fake_loading={carregando_deletar_aditivos}
        setFake_loading={setFake_loading}
        filtradoAtivo={filtradoAtivo}
        totalRef={total1}
      />
      <FormularioAditivos
        open={open}
        update={update}
        fecharGaveta={fecharGaveta}
        nome_produto={nome_produto}
        setNome_produto={setNome_produto}
        fabricante={fabricante}
        setFabricante={setFabricante}
        setFabricante_id={setFabricante_id}
        tipo_aditivo={tipo_aditivo}
        setTipo_aditivo={setTipo_aditivo}
        setTipo_aditivo_id={setTipo_aditivo_id}
        tipo_formulacao={tipo_formulacao}
        setTipo_formulacao={setTipo_formulacao}
        setTipo_formulacao_id={setTipo_formulacao_id}
        tab_selecionar_atual={tab_selecionar_atual}
        setTab_selecionar_atual={setTab_selecionar_atual}
        modo_uso={modo_uso}
        setModo_uso={setModo_uso}
        observacao={observacao}
        setObservacao={setObservacao}
        cultura={cultura}
        setCultura={setCultura}
        setCultura_id={setCultura_id}
        doses_culturas_adicionados={doses_culturas_adicionados}
        setDoses_culturas_adicionados={setDoses_culturas_adicionados}
        dose={dose}
        setDose={setDose}
        setDose_id={setDose_id}
        valor={valor}
        setValor={setValor}
        fakeLoading_cultura={fake_loading_cultura}
        carregando_salvar_aditivos={carregando_salvar_aditivos}
        carregando_salvar_aditivos_editar={carregando_editar_aditivos}
        adicionar_dose={adicionarCultura}
        remover_cultura_dose={remover_cultura_dose}
        salvarAditivos={salvarAditivo}
        dataCulturas={dataCulturas}
        dataUnidade={data_unidade}
        dataFormulacao={dataFormulacao}
        dataFabricante={dataFabricante}
        dataTipoAditivos={data_tipos_aditivos}
      />
    </ViewPage>
  )
}

export default OutrosAditivos
